export default __webpack_public_path__ + "static/media/motC1.8d821c3e.png";